import { rem } from "./auth-service-tools172.js";
import "react";
import "./auth-service-tools177.js";

function getPositionVariables() {
  let _position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "top-end";

  let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const variables = {
    "--indicator-top": void 0,
    "--indicator-bottom": void 0,
    "--indicator-left": void 0,
    "--indicator-right": void 0,
    "--indicator-translate-x": void 0,
    "--indicator-translate-y": void 0
  };

  const _offset = rem(offset);

  const [position, placement] = _position.split("-");

  if (position === "top") {
    variables["--indicator-top"] = _offset;
    variables["--indicator-translate-y"] = "-50%";
  }

  if (position === "middle") {
    variables["--indicator-top"] = "50%";
    variables["--indicator-translate-y"] = "-50%";
  }

  if (position === "bottom") {
    variables["--indicator-bottom"] = _offset;
    variables["--indicator-translate-y"] = "50%";
  }

  if (placement === "start") {
    variables["--indicator-left"] = _offset;
    variables["--indicator-translate-x"] = "-50%";
  }

  if (placement === "center") {
    variables["--indicator-left"] = "50%";
    variables["--indicator-translate-x"] = "-50%";
  }

  if (placement === "end") {
    variables["--indicator-right"] = _offset;
    variables["--indicator-translate-x"] = "50%";
  }

  return variables;
}

export { getPositionVariables };